<template>
  <svg viewBox="0 0 14 5" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 5L0 0L14 7.21715e-07L7 5Z"/>
  </svg>
</template>

<style scoped lang="scss">
svg {
  width: 14px;
  height: 5px;
}
</style>